import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "@/src/components/ui/form";
import { Separator } from "@/src/components/ui/separator";
import { emptyOperatorForm, OperatorForm } from "./operator.schema";
import { GeneralInfo } from "./GeneralInfo";
import { BankDetails } from "./BankDetails";
import { Payments } from "./Payments";
import { useCallback, useEffect } from "react";
import { TermsAndConditions } from "./TermsAndConditions";
import { GoodToKnow } from "./GoodToKnow";
import { useSubscribe } from "@/src/lib/actions";
import { BoardingInformation } from "./BoardingInformation";
import { YachtLocation } from "../model";
import { VisibilitySettings } from "./VisibilitySettings";
import { YachtsLabels } from "./YachtsLabels";

export type EditOperatorFormProps = {
  locations?: YachtLocation[];
  operator?: OperatorForm;
  onSubmit?: (data: OperatorForm) => void;
};

export function EditOperatorForm({ operator, locations, onSubmit: _onSubmit }: EditOperatorFormProps) {
  const form = useForm<OperatorForm>({
    resolver: zodResolver(OperatorForm),
    defaultValues: operator ?? emptyOperatorForm(locations?.map((l) => l.id) ?? []),
    mode: "onTouched",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    operator && form.reset(operator);
  }, [operator]);

  const onSubmit = useCallback(
    form.handleSubmit(
      (data) => {
        _onSubmit?.(data);
      },
      () => {
        const values = form.getValues();
        const issues = OperatorForm.safeParse(values).error?.issues ?? [];

        if (issues.some((issue) => issue.message === "Total amount should be 100")) {
          const paymentsLen = values.operatorPayments.paymentSchedule.length;
          for (let i = 0; i < paymentsLen; i++) {
            form.setError(`operatorPayments.paymentSchedule.${i}.amount`, {
              type: "manual",
              message: "Total amount should be 100",
            });
          }
        }
        console.error(form, form.getValues());
      },
    ),
    [form],
  );

  // useEffect(() => {
  //   (window as any).getValue = form.getValues;
  // }, []);

  useSubscribe("operator:save", onSubmit);

  return (
    <Form {...form}>
      <form className="flex flex-col gap-6" onSubmit={onSubmit}>
        <GeneralInfo locations={locations ?? []} />
        <Separator />
        <VisibilitySettings />
        <Separator />
        <YachtsLabels />
        <Separator />
        <BankDetails />
        <Separator />
        <Payments />
        <Separator />
        <TermsAndConditions />
        <Separator />
        <GoodToKnow />
        <Separator />
        <BoardingInformation locations={locations ?? []} />
        <Separator />
      </form>
    </Form>
  );
}
